module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'hide-global-menu category-open': _vm.activeCategory != '', 'menu-open': _vm.showModal
    },
    attrs: {
      "id": "app"
    }
  }, [_c('hero', {
    staticClass: "home-hero",
    attrs: {
      "content": _vm.heroContent
    },
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('voters', {
    staticClass: "voters hideme clearfix"
  }), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "modaltype": _vm.modalType,
      "categories": _vm.categories
    },
    on: {
      "clicked": _vm.categoryClicked,
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('categories', {
    attrs: {
      "categories": _vm.categories
    },
    on: {
      "clicked": _vm.categoryClicked
    }
  }), _vm._v(" "), _c('click-thru', {
    attrs: {
      "clickThru": _vm.clickThru
    },
    on: {
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('social'), _vm._v(" "), _c('legal'), _vm._v(" "), _c('category-pages', {
    attrs: {
      "id": "categoryPages",
      "categories": _vm.categories,
      "activeCategory": _vm.activeCategory,
      "previousCategory": _vm.previousCategory
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('back-to-top'), _vm._v(" "), _c('header', {
    attrs: {
      "id": "stickyHeader"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner laurels clearfix"
  }, [_c('div', {
    staticClass: "awards-container"
  }, [_c('div', {
    staticClass: "award-wrapper"
  }, [_c('div', {
    staticClass: "awards-inner hideme",
    attrs: {
      "id": "goldenGlobe"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/award1.png"),
      "alt": "Awards Tout"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "awards-inner hideme",
    attrs: {
      "id": "SAG"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/award2.png"),
      "alt": "Awards Tout"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "award-wrapper"
  }, [_c('div', {
    staticClass: "awards-inner hideme",
    attrs: {
      "id": "criticsChoice"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/award3.png"),
      "alt": "Awards Tout"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "awards-inner hideme",
    attrs: {
      "id": "AFI"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/award4.png"),
      "alt": "Awards Tout"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro hideme"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/SOW_Logo_w1.1.png"),
      "alt": "The Shape of Water"
    }
  }), _vm._v(" "), _c('p', [_vm._v("A powerful vision of a creative master feeling totally, joyously free.")]), _vm._v(" "), _c('div', {
    staticClass: "byline home"
  }, [_vm._v("- INDIEWIRE")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d893a88", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d893a88","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Main.vue
// module id = 397
// module chunks = 0